import { Component, OnInit, ViewChild } from '@angular/core';
import { MaestrasService } from 'src/app/services/maestra/maestras.service';
import { Estado } from 'src/app/models/Estado';
import { AnhoService } from 'src/app/services/Anho.service';
import { Anho } from 'src/app/models/Anho';
import { Fur } from 'src/app/models/Fur';
import { RecupPartesFchInicio, DscTituloPaginator, isNotEmptyList, ngClassAceptarModal, ngClassSalirModal, dscEtiquetaBtnAcepModal, dscEtiquetaBtnSalirModal, openModalMensaje, CodTipoFichaFUR,  GetAnho, NumIdEstadoHeEvaluacionSuperv } from 'src/app/general/variables';
import { MatTableDataSource, MatPaginator, MatSort, MatDialogRef, MatDialog } from '@angular/material';
import { FurSeguimientoFiltro } from 'src/app/models/FurSeguimientoFiltro';
import { NavModalComponent } from '../../General/nav-modal/nav-modal.component';

import { FurSeguimientoService } from 'src/app/services/fur-seguimiento..service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-modal-busq-fur-compl',
  templateUrl: './modal-busq-fur-compl.component.html',
  styleUrls: ['./modal-busq-fur-compl.component.css']
})
export class ModalBusqFurComplComponent implements OnInit {

  listEstados: Estado[] = [];
  listAnho: Anho[] = [];
  listFur: Fur[] = [];
  recupPartesFchInicio = RecupPartesFchInicio;
  matTableColumnsDef = ['item', 'codFur', 'Estado', 'recepcion', 'Asunto', 'entidad', 'seleccionar'];
  strCodFur: string = null;
  strAnho: string = GetAnho().toString();
  numIdEstado: number = NumIdEstadoHeEvaluacionSuperv;
  isNotEmptyList = isNotEmptyList;
  ngClassAceptarModal = ngClassAceptarModal;
  ngClassSalirModal = ngClassSalirModal;
  dscEtiquetaBtnAcepModal = dscEtiquetaBtnAcepModal;
  dscEtiquetaBtnSalirModal = dscEtiquetaBtnSalirModal;
  strDscTitulo = 'Búsqueda de FUR';

  dataSource: MatTableDataSource<Fur>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @ViewChild(NavModalComponent) navModalC: NavModalComponent;

  constructor(protected maestrasService: MaestrasService,
              protected anhoService: AnhoService,
              private dialogRef: MatDialogRef<ModalBusqFurComplComponent>,
              public dialog: MatDialog,
              protected furSeguimientoService: FurSeguimientoService,
              private spinner: NgxSpinnerService) {


      this.dataSource = new MatTableDataSource();

    }

  ngOnInit() {

    this.navModalC.setDatosNavModal2(this.strDscTitulo);

    this.maestrasService.listarEstadoPorFicha(CodTipoFichaFUR).subscribe(data => {

      this.listEstados = data;

    });

    this.anhoService.listarAnho().subscribe(data => {

        this.listAnho = data;

    });


  }

  _cancelar() {

    this.dialogRef.close();

  }

  _resetMatTable() {

    setTimeout(() => {

      this.dataSource = new MatTableDataSource(this.listFur);

      if (this.paginator != null) {this.paginator._intl.itemsPerPageLabel = DscTituloPaginator; }

      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

    }, 1);

  }

  _checkSeleccionar(codFur: string, data: any) {

    this.listFur.forEach(data1 => {

        if (data1.cfurCodigo == codFur) {

          data1.flgSeleccionar = data.target.checked;

        } else {

          data1.flgSeleccionar = false;
        }
    });

  }

  _aceptar() {

    const vFurSel: Fur =  this.listFur.find(x => x.flgSeleccionar == true);

    if (!vFurSel) {

      openModalMensaje(this.strDscTitulo, 'Debe seleccionar un FUR, por favor verifique', this.dialog);

      return;

    }

    this.dialogRef.close(vFurSel);

  }

  _buscar() {

    const vFurSeguimientoFiltro: FurSeguimientoFiltro = new FurSeguimientoFiltro();
    const vFchInicial = '01/01/' + this.strAnho;
    const vFchFinal = '31/12/' + this.strAnho;

    this.listFur = [];

    vFurSeguimientoFiltro.cfurCodigo = this.strCodFur;

    vFurSeguimientoFiltro.strFechaIni = vFchInicial;
    vFurSeguimientoFiltro.strFechaFin = vFchFinal;
    vFurSeguimientoFiltro.nfurIdestado = this.numIdEstado;

    this.spinner.show();

    console.log('==========0vFurSeguimientoFiltro');
    console.log(JSON.stringify(vFurSeguimientoFiltro));

    this.furSeguimientoService.ListarGCSeguimiento(vFurSeguimientoFiltro).subscribe(data => {

      this.spinner.hide();

      if (data) {

        this.listFur = data;

      } else {

        openModalMensaje(this.strDscTitulo, 'No se encontró ningún registro, por favor verifique', this.dialog);

      }

      this._resetMatTable();

    }, err => {

      this.spinner.hide();
      console.log(err);

    });


  }

}
